<template>
  <div class="w-full">
    <el-select v-model='leader'
               class="w-full" filterable
               :placeholder='placeholder'
               clearable>
      <el-option :label='item.label' :value='item.value' v-for='(item) in options' :key='item.value'>
        <span style='float: left'> {{ item.label }}</span>
        <span style='float: right;color: #909399'> {{ item.total }}</span>
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'ProductLeaderSelect',
  props: {
    leaderId: {
      type: [Number, String]
    },
    leaderType: {
      type: [Number, String],
      default() {
        return 'product'
      }
    },
    placeholder: {
      type: [ String],
      default() {
        return '产品负责人'
      }
    }
  },
  data() {
    return {
      options: []
    }
  },
  computed: {
    leader: {
      get() {
        return this.leaderId
      },
      set(val) {
        this.$emit('update:leaderId', val)
        this.changeLeader(val)
      }
    }
  },
  watch: {
    'leaderType'(val) {
      if (val) {
        this.getOptions()
      }
    }
  },
  methods: {
    async getOptions() {
      this.options = []
      const { list } = await this.$api.productLeaderOptions(this.leaderType)
      this.options = list
    },
    changeLeader(val) {
      if (val && this.options.length) {
        const option = this.options.find(value => value.value === val)
        this.$emit('selected', option)
        this.$emit('update:leader-name', option.label || '')
      } else {
        this.$emit('selected', {})
      }

    },
    // 清空选择的方法
    clear() {
      this.leader = null
      this.$emit('update:leaderId', null)
      this.$emit('selected', {})
      this.$emit('update:leader-name', '')
    }
  },
  created() {
    this.getOptions()
  }
}
</script>

<style scoped>

</style>
